import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {StoreState} from "../store"
import {useSelector} from "react-redux"
import {getSelectedCity, setCookie} from "../utils/cookies"

export interface AppSliceProps {
  selectedCityId?: number
  selectedBranch?: string
}

const initialState: AppSliceProps = {
  selectedCityId: getSelectedCity(),
  selectedBranch: undefined
}

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setCity: (
      state,
      action: PayloadAction<AppSliceProps["selectedCityId"]>
    ) => {
      state.selectedCityId = action.payload
      if (action.payload !== undefined)
        setCookie("selectedCity", action.payload.toString())
    },
    setBranch: (
      state,
      action: PayloadAction<AppSliceProps["selectedBranch"]>
    ) => {
      state.selectedBranch = action.payload
    }
  }
})

export default appSlice.reducer

export const {setCity, setBranch} = appSlice.actions

const selectAll = (state: StoreState) => state.app

export const useGetApp = () => useSelector(selectAll)
